import { render, staticRenderFns } from "./blesson.vue?vue&type=template&id=29098868&scoped=true&"
import script from "./blesson.vue?vue&type=script&lang=js&"
export * from "./blesson.vue?vue&type=script&lang=js&"
import style0 from "./blesson.vue?vue&type=style&index=0&id=29098868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29098868",
  null
  
)

export default component.exports